import { useState, useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/LoadingSpinner';
import { billingApi } from '../../services/billing';

export default function VendorBillingSuccess() {
  const [syncDone, setSyncDone] = useState(false);
  const queryClient = useQueryClient();

  // On mount, trigger a sync from Stripe, then allow the overview query to run
  useEffect(() => {
    let cancelled = false;
    billingApi.syncSubscription()
      .catch(() => {})
      .finally(() => {
        if (!cancelled) {
          // Invalidate any cached overview so we get fresh data
          queryClient.invalidateQueries({ queryKey: ['billing', 'overview'] });
          setSyncDone(true);
        }
      });
    return () => { cancelled = true; };
  }, [queryClient]);

  const { data: overview } = useQuery({
    queryKey: ['billing', 'overview', 'success'],
    queryFn: () => billingApi.getOverview().then((r) => r.data),
    enabled: syncDone,
  });

  const planName = overview?.current_plan?.name;
  const isReady = syncDone && overview?.current_plan != null;

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 max-w-md w-full text-center">
        {/* Green checkmark */}
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-emerald-50 mb-6">
          <svg
            className="h-8 w-8 text-emerald-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Plan Updated!
        </h1>

        {isReady ? (
          <p className="text-sm text-emerald-600 font-medium mb-6">
            Your {planName} plan is now active!
          </p>
        ) : (
          <div className="mb-6">
            <p className="text-sm text-slate-500 mb-4">
              Updating your subscription...
            </p>
            <div className="flex justify-center">
              <LoadingSpinner size="sm" />
            </div>
          </div>
        )}

        <Link
          to="/vendor/billing"
          className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl px-6 py-2.5 text-sm font-semibold hover:from-blue-700 hover:to-blue-800"
        >
          Go to Billing
        </Link>
      </div>
    </div>
  );
}
